if (window.innerWidth < 991) {
    var swiper = new Swiper(".block__blog-article", {
        slidesPerView: 1,
        pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
        },
        mousewheel: {
            forceToAxis: true,
        },
        navigation: {
            nextEl: '.swiper-buttons-next',
            prevEl: '.swiper-buttons-prev',
        },
    });
}
